// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unternehmen/unsere-unternehmenspolitik/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unternehmenUnsereUnternehmenspolitikDE: PageEntry = {
  id: "post.unternehmen-unsere-unternehmenspolitik",
  locale: "de",
  slug: "unternehmen/unsere-unternehmenspolitik",
  seo: {
    navLabel: "Unternehmenspolitik",
    title: "Unternehmenspolitik bei Dietz Federn",
    description: "Unternehmenspolitik bei Dietz Federn",
  },
  type: "post",
  h1: "Unternehmenspolitik bei Dietz Federn",
  blocks: [
    { kind: "image", src: "/images/live/dietz_aussen-1200x375.jpg", alt: "Firmengebäude Dietz", width: 1200, height: 375 },
    { kind: "heading", level: 2, text: "Unsere Unternehmenspolitik" },
    { kind: "paragraph", text: "Unsere Grundsätze und Werte sind in unserer DIETZ-Unternehmenspolitik und Vision verankert. Sie setzt sich aus sechs Einzelpolitiken zusammen. Die Abstimmung zwischen den Beauftragten bzw. Verantwortlichen der Bereiche ist besonders wichtig, um eine umfassende Prüfung von Sachver­hal­ten zu gewährleisten. Den Mitarbeitenden werden regelmäßig durch Schulungen oder Themenwochen die Aspekte der Unternehmenspolitik näher gebracht." },
    { kind: "image", src: "/images/live/Vision-mit-Text.png", alt: "Vision mit Text", width: 1920, height: 1080 }
  ],
};
